import styled, { css } from 'styled-components';
import React, { CSSProperties } from 'react';

interface Props {
	imageUrl: string;
	style?: CSSProperties;
	withCheckeredBackground?: boolean;
}

export const PngPreview = ({ imageUrl, withCheckeredBackground = true, style }: Props) => {
	return (
		<CheckeredBackground style={style} $withCheckeredBackground={withCheckeredBackground}>
			<img
				src={imageUrl}
				alt="signature"
				style={{
					width: '100%',
					height: '100%',
					objectFit: 'contain',
				}}
			/>
		</CheckeredBackground>
	);
};

const CheckeredBackground = styled.div<{
	$withCheckeredBackground: Props['withCheckeredBackground'];
}>`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0.2rem;

	border: 1px dashed #d3d8da;
	border-radius: 0.5rem;

	${({ $withCheckeredBackground }) => {
		if ($withCheckeredBackground) {
			return css`
				background-image: linear-gradient(45deg, #ccc 26%, transparent 25%),
					linear-gradient(135deg, #ccc 26%, transparent 25%),
					linear-gradient(45deg, transparent 75%, #ccc 75%),
					linear-gradient(135deg, transparent 75%, #ccc 75%);
				background-size: 21px 21px;
				background-position:
					0 0,
					10px 0,
					10px -10px,
					0 10px;
			`;
		}
	}}
`;
